import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-homethree-courses',
    templateUrl: './homethree-courses.component.html',
    styleUrls: ['./homethree-courses.component.scss']
})
export class HomethreeCoursesComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }
    sectionTitle: sectionTitleContent[] = [
        {
            title: 'Our Solutions',
            paragraphText: 'Agentic AI, Made Effortless.'
        }
    ]
    coursesInfo: Info[] = [
        {
            paragraphText: 'Get the most dedicated consultation for your life-changing course. Earn a certification for your effort and passion',
            linkText: 'Join Free Now.',
            link: 'contact'
        }
    ]
    singleCoursesBox: coursesContent[] = [
        {
            courseImg: 'https://imgvid.blob.core.windows.net/imgvid/product1.jpg',
            coursePrice: 'Free',
            coursePriceClass: 'free',
            authorImg: 'accessible',
            authorName: 'Human Safety',
            title: 'Keep a Check on Threats for Risk Management',
            link: 'courses-details',
            paragraphText: 'Live headcount, fall detection, distress signals, and crowd monitoring. Deploy completely private on-premise support with live alerts reporting anomalies.',
            courseDuration: '8 Weeks Long',
            studentApply: 'Hospitals, Care Centers, Public Areas, Estates.'
        },
        {
            courseImg: 'https://imgvid.blob.core.windows.net/imgvid/product2.jpg',
            coursePrice: '$49',
            coursePriceClass: 'paid',
            authorImg: 'schema',
            authorName: 'Workplace Analytics',
            title: 'Generate Digital-Twin of Your Workplace Activites',
            link: 'courses-details',
            paragraphText: 'Get vision AI to spot non-compliance, training gaps and protocol failures. Get weekly reports and receive live alerts on your business messaging app.',
            courseDuration: '7 Weeks Long',
            studentApply: 'Offices, Business Centers, Work Sites.'
        },
        {
            courseImg: 'https://imgvid.blob.core.windows.net/imgvid/product3.jpg',
            coursePrice: '$69',
            coursePriceClass: 'paid',
            authorImg: 'precision_manufacturing',
            authorName: 'Turnkey Deployments',
            title: 'Custom Models with Real-time Actions',
            link: 'courses-details',
            paragraphText: 'Get custom AI trained on your proprietary datasets to meet your specific goals. Deploy intelligent workflows on our resilient on-premise server..',
            courseDuration: 'Duration: Varies',
            studentApply: 'Robotics, Quality Checks, Logistics, Operations.'
        }
    ]

}
class sectionTitleContent {
    title : string;
    paragraphText : string;
}
class Info {
    paragraphText : string;
    linkText : string;
    link : string;
}
class coursesContent {
    courseImg : string;
    coursePrice : string;
    coursePriceClass : string;
    authorImg : string;
    authorName : string;
    title : string;
    link : string;
    paragraphText : string;
    courseDuration : string;
    studentApply : string;
}